 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"c-head-section":"c-head-section","c-dashboard_disasters-section":"c-dashboard_disasters-section","c-dashboard_management-section":"c-dashboard_management-section","c-dashboard_reports-section":"c-dashboard_reports-section"}[chunkId]||chunkId) + "-legacy." + {"c-head-section":"4d422e50","chunk-03ae8253":"3f36ac94","chunk-1b4c7e58":"a5e25cc8","chunk-2c93cd46":"e8c462a5","chunk-5e249416":"6737c269","chunk-622ff934":"223f5cf0","chunk-0171b1a4":"f62586fc","chunk-41944949":"02820749","chunk-8848a538":"8e57744a","chunk-8e8bdd52":"ca3807e2","chunk-b1cbcfca":"9a1dc0fc","chunk-bb3f796a":"cbd4dacb","chunk-2d0a4456":"f2415807","chunk-2d0ae9c2":"618f9368","chunk-2d0b25c2":"af17f3a7","chunk-2d0b92be":"5f61c059","chunk-2d0b9494":"fa6df94c","chunk-2d0d621d":"fa2d6ea2","chunk-2d0ddfd2":"a2a0dedc","chunk-2d0e1f08":"80cf7149","chunk-2d0e5d60":"3d531b1a","chunk-2d0e980d":"c6a944ed","chunk-2d208a9b":"8ceb86b0","chunk-2d210fe0":"6b3752e6","chunk-2d21a339":"66e4cbeb","chunk-2d221ca0":"ed602ff1","chunk-2d222729":"dd79219b","chunk-2d2257e4":"ce7b0d6b","chunk-2d226ce7":"ba81a9ea","chunk-2d22a1b5":"ebc45524","chunk-3685e680":"17c7416f","chunk-387ed3ca":"8f93ceba","chunk-3b768283":"dacc9a7b","chunk-48a7737f":"86bbed0f","chunk-a57eda0a":"f9ee9149","c-dashboard_disasters-section":"0d426963","c-dashboard_management-section":"74a5fad6","c-dashboard_reports-section":"c6211cdd","chunk-3f6ed5f7":"9f076ead"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"c-head-section":1,"chunk-03ae8253":1,"chunk-5e249416":1,"chunk-0171b1a4":1,"chunk-41944949":1,"chunk-8848a538":1,"chunk-8e8bdd52":1,"chunk-b1cbcfca":1,"chunk-bb3f796a":1,"chunk-387ed3ca":1,"chunk-3b768283":1,"c-dashboard_disasters-section":1,"c-dashboard_management-section":1,"c-dashboard_reports-section":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"c-head-section":"c-head-section","c-dashboard_disasters-section":"c-dashboard_disasters-section","c-dashboard_management-section":"c-dashboard_management-section","c-dashboard_reports-section":"c-dashboard_reports-section"}[chunkId]||chunkId) + "." + {"c-head-section":"0c3b0cb8","chunk-03ae8253":"a1fc9b64","chunk-1b4c7e58":"31d6cfe0","chunk-2c93cd46":"31d6cfe0","chunk-5e249416":"2030c598","chunk-622ff934":"31d6cfe0","chunk-0171b1a4":"e32f5ad7","chunk-41944949":"a02df452","chunk-8848a538":"3fd27851","chunk-8e8bdd52":"70f5b621","chunk-b1cbcfca":"d5ec48be","chunk-bb3f796a":"7829258d","chunk-2d0a4456":"31d6cfe0","chunk-2d0ae9c2":"31d6cfe0","chunk-2d0b25c2":"31d6cfe0","chunk-2d0b92be":"31d6cfe0","chunk-2d0b9494":"31d6cfe0","chunk-2d0d621d":"31d6cfe0","chunk-2d0ddfd2":"31d6cfe0","chunk-2d0e1f08":"31d6cfe0","chunk-2d0e5d60":"31d6cfe0","chunk-2d0e980d":"31d6cfe0","chunk-2d208a9b":"31d6cfe0","chunk-2d210fe0":"31d6cfe0","chunk-2d21a339":"31d6cfe0","chunk-2d221ca0":"31d6cfe0","chunk-2d222729":"31d6cfe0","chunk-2d2257e4":"31d6cfe0","chunk-2d226ce7":"31d6cfe0","chunk-2d22a1b5":"31d6cfe0","chunk-3685e680":"31d6cfe0","chunk-387ed3ca":"4a21677d","chunk-3b768283":"d3184c80","chunk-48a7737f":"31d6cfe0","chunk-a57eda0a":"31d6cfe0","c-dashboard_disasters-section":"4ba08f6c","c-dashboard_management-section":"b3671fdb","c-dashboard_reports-section":"79db4438","chunk-3f6ed5f7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
